module.exports = __webpack_public_path__ + "img/lianhuashan.efb62476.jpg";